import { createFileRoute } from "@tanstack/react-router";
import Moto from "@/pages/Moto";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/moto/")({
  head: () => routeHead("/moto/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Moto />
  );
}
